import { useEffect, useRef, useState } from 'react';
import './Landing.css';
import logoCompleto from '../assets/Niva - Montañas-horizontal.png';

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const sliderRef = useRef<NodeJS.Timeout | null>(null);
  const [isPaused, setIsPaused] = useState(false);

  const testimonials = [
    {
      id: 1,
      name: 'Mariana López',
      location: 'Palermo',
      text: 'Encontré una cocinera con excelentes reseñas en 10 minutos.',
      initial: 'M',
      color: '#4F46E5'
    },
    {
      id: 2,
      name: 'Carlos Méndez',
      location: 'Belgrano',
      text: 'La app hace todo fácil. Contraté una limpieza profunda sin complicaciones.',
      initial: 'C',
      color: '#7C3AED'
    },
    {
      id: 3,
      name: 'Sofía Ramírez',
      location: 'Caballito',
      text: 'Servicio de cuidado de adultos excelente. Me encanta poder ver reseñas reales.',
      initial: 'S',
      color: '#2563EB'
    },
    {
      id: 4,
      name: 'Lucas Torres',
      location: 'Recoleta',
      text: 'Rápido, confiable y transparente. Ya contraté 3 veces sin problemas.',
      initial: 'D',
      color: '#059669'
    }
  ];

  // Navbar scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Testimonial slider auto-rotation
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (!prefersReducedMotion && !isPaused) {
      sliderRef.current = setInterval(() => {
        setActiveTestimonial(prev => (prev + 1) % testimonials.length);
      }, 3500);
    }

    return () => {
      if (sliderRef.current) clearInterval(sliderRef.current);
    };
  }, [isPaused, testimonials.length]);

  const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const element = document.querySelector(target);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="ln-wrapper">
      {/* Navbar */}
      <nav className={`ln-nav ${scrolled ? 'ln-nav--scrolled' : ''}`}>
        <div className="ln-nav__container">
          <img src={logoCompleto} alt="Niva" className="ln-nav__brand-img" />
          
          <div className="ln-nav__links">
            <a href="#ln-como" onClick={(e) => handleSmoothScroll(e, '#ln-como')}>Cómo</a>
            <a href="#ln-valor" onClick={(e) => handleSmoothScroll(e, '#ln-valor')}>Beneficios</a>
            <a href="#ln-test" onClick={(e) => handleSmoothScroll(e, '#ln-test')}>Testimonios</a>
            <a href="#ln-faq" onClick={(e) => handleSmoothScroll(e, '#ln-faq')}>FAQs</a>
          </div>

         <a href="/seleccion" className="ln-btn ln-btn--primary">
            Entrar a la app 
          </a> 
          

        </div>
      </nav>

      {/* Hero */}
      <section className="ln-hero">
        {/* Decorative Background Elements */}
        <div className="ln-hero__bg-decorations" aria-hidden="true">
          <div className="ln-hero__blob ln-hero__blob--1"></div>
          <div className="ln-hero__blob ln-hero__blob--2"></div>
          <div className="ln-hero__blob ln-hero__blob--3"></div>
          <div className="ln-hero__grid"></div>
        </div>
        
        <div className="ln-hero__container">
          <div className="ln-hero__content">
            <h1 className="ln-hero__title">
            Encontrá la persona indicada para tu casa.
            </h1>
            <p className="ln-hero__subtitle">
            Desde cocinera, niñera o limpieza: más de 200 perfiles revisados esperan para trabajar. Contratá fácil, en minutos y desde un solo lugar.
            </p>
            <div className="ln-hero__actions">
              <a href="/seleccion" className="ln-btn ln-btn--primary ln-btn--large">
                  Comenzar ahora 
              </a>  
              
              <a 
                href="#ln-como" 
                className="ln-btn ln-btn--secondary ln-btn--large"
                onClick={(e) => handleSmoothScroll(e, '#ln-como')}
              >
                Saber más
              </a>
            </div>
          </div>
          
          <div className="ln-hero__illustration" aria-hidden="true">
            <div className="ln-phone">
              <div className="ln-phone__screen">
                {/* Header */}
                <div className="ln-phone__header">
                  <div className="ln-phone__header-logo"></div>
                  <div className="ln-phone__header-profile"></div>
                </div>

                {/* Map Preview */}
                <div className="ln-phone__map">
                  <div className="ln-phone__map-pin"></div>
                  <div className="ln-phone__map-pin ln-phone__map-pin--2"></div>
                  <div className="ln-phone__map-text">BUENOS AIRES</div>
                </div>

                {/* Results Title */}
                <div className="ln-phone__results-title">Oportunidades de trabajo</div>

                {/* Job Cards (ofertas) */}
                <div className="ln-phone__jobs">
                  {/* Trabajo 1 */}
                  <div className="ln-phone__job">
                    <div className="ln-phone__job-header">
                      <div className="ln-phone__job-title">Limpieza en Palermo</div>
                      <div className="ln-phone__job-badge">3 vacantes</div>
                    </div>
                    <div className="ln-phone__job-prices">
                      <div className="ln-phone__job-price">$3.500/hora</div>
                    </div>
                    <div className="ln-phone__job-meta">
                      <div className="ln-phone__job-type">• Urgente - hoy</div>
                      <div className="ln-phone__job-distance">1.2 km</div>
                    </div>
                  </div>

                  {/* Trabajo 2 */}
                  <div className="ln-phone__job">
                    <div className="ln-phone__job-header">
                      <div className="ln-phone__job-title">Cocina en Caballito</div>
                      <div className="ln-phone__job-badge">Pago mensual</div>
                    </div>
                    <div className="ln-phone__job-prices">
                      <div className="ln-phone__job-price">$320.000/mes</div>
                    </div>
                    <div className="ln-phone__job-meta">
                      <div className="ln-phone__job-type">• Hace 1 semana</div>
                      <div className="ln-phone__job-distance">2.8 km</div>
                    </div>
                  </div>

                  {/* Trabajo 3 */}
                  <div className="ln-phone__job">
                    <div className="ln-phone__job-header">
                      <div className="ln-phone__job-title">Niñera en Recoleta</div>
                      <div className="ln-phone__job-badge">1 turno</div>
                    </div>
                    <div className="ln-phone__job-prices">
                      <div className="ln-phone__job-price">$3.700/hora</div>
                    </div>
                    <div className="ln-phone__job-meta">
                      <div className="ln-phone__job-type">• Hace 2 días</div>
                      <div className="ln-phone__job-distance">5.7 km</div>
                    </div>
                  </div>
                </div>

                {/* View All Button */}
                <div className="ln-phone__view-all">Ver todos los trabajos →</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cómo funciona */}
      <section id="ln-como" className="ln-como">
        <div className="ln-como__container">
          <h2 className="ln-section-title">Cómo funciona</h2>
          <p className="ln-section-subtitle">
            Tres pasos simples para contratar el servicio que necesitás
          </p>

          <div className="ln-steps">
            <div className="ln-step">
              <div className="ln-step__icon ln-step__icon--search"></div>
              <h3 className="ln-step__title">Elegí</h3>
              <p className="ln-step__text">
              Seleccioná el servicio: con cama, por hora, niñera o evento.
              </p>
            </div>

            <div className="ln-step">
              <div className="ln-step__icon ln-step__icon--select"></div>
              <h3 className="ln-step__title">Creá</h3>
              <p className="ln-step__text">
              Armá tu solicitud: compará perfiles, reseñas y precios transparentes.
              </p>
            </div>

            <div className="ln-step">
              <div className="ln-step__icon ln-step__icon--check"></div>
              <h3 className="ln-step__title">Contratá</h3>
              <p className="ln-step__text">
                Reservá en segundos y recibí la confirmación directamente de la persona que ofrece el servicio.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Empleados Encontrados */}
      <section className="ln-results">
        <div className="ln-results__container">
          <div className="ln-results__header">
            <h2 className="ln-results__greeting">El placer de encontrar lo que buscás para tu casa.</h2>
            <div className="ln-results__meta">
              <span className="ln-results__service">Limpieza de departamento</span>
              <span className="ln-results__location">Chacarita, CABA</span>
              <span className="ln-results__rate">$3500/hora</span>
            </div>
          </div>

          <div className="ln-results__list">
            {/* Profesional 1 */}
            <div className="ln-results__card">
              <div className="ln-results__card-header">
                <div className="ln-results__card-left">
                  <div className="ln-results__avatar">
                    <div className="ln-results__avatar-img" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                      <span>ID</span>
                    </div>
                  </div>
                  <div className="ln-results__info">
                    <h3 className="ln-results__name">Juana Gonzalez</h3>
                    <div className="ln-results__rating">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="ln-results__star"></span>
                      ))}
                      <span className="ln-results__rating-text">4.8 (127 reseñas)</span>
                    </div>
                    <p className="ln-results__availability">Palermo, CABA • Lunes a Viernes, 8:00 - 18:00</p>
                    <p className="ln-results__posted">Postulado el 9 de septiembre de 2025</p>
                  </div>
                </div>
                <a href="/busco-niva/login" className="ln-results__view-profile">Ver perfil →</a>
              </div>
              <div className="ln-results__card-footer">
                <button className="ln-results__btn">Enviar mensaje</button>
              </div>
            </div>

            {/* Profesional 2 */}
            <div className="ln-results__card">
              <div className="ln-results__card-header">
                <div className="ln-results__card-left">
                  <div className="ln-results__avatar">
                    <div className="ln-results__avatar-img" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
                      <span>MI</span>
                    </div>
                  </div>
                  <div className="ln-results__info">
                    <h3 className="ln-results__name">Mariela Ibarra</h3>
                    <div className="ln-results__rating">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="ln-results__star"></span>
                      ))}
                      <span className="ln-results__rating-text">4.9 (89 reseñas)</span>
                    </div>
                    <p className="ln-results__availability">Palermo, CABA • Lunes a Viernes, 9:00 - 17:00</p>
                    <p className="ln-results__posted">Postulado el 8 de septiembre de 2025</p>
                  </div>
                </div>
                <a href="/busco-niva/login" className="ln-results__view-profile">Ver perfil →</a>
              </div>
              <div className="ln-results__card-footer">
                <button className="ln-results__btn">Enviar mensaje</button>
              </div>
            </div>

            {/* Profesional 3 */}
            <div className="ln-results__card">
              <div className="ln-results__card-header">
                <div className="ln-results__card-left">
                  <div className="ln-results__avatar">
                    <div className="ln-results__avatar-img" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
                      <span>CR</span>
                    </div>
                  </div>
                  <div className="ln-results__info">
                    <h3 className="ln-results__name">Rosa Ramírez</h3>
                    <div className="ln-results__rating">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="ln-results__star"></span>
                      ))}
                      <span className="ln-results__rating-text">5.0 (156 reseñas)</span>
                    </div>
                    <p className="ln-results__availability">Belgrano, CABA • Lunes a Sábado, 7:00 - 19:00</p>
                    <p className="ln-results__posted">Postulado el 7 de septiembre de 2025</p>
                  </div>
                </div>
                <a href="/busco-niva/login" className="ln-results__view-profile">Ver perfil →</a>
              </div>
              <div className="ln-results__card-footer">
                <button className="ln-results__btn">Enviar mensaje</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Beneficios */}
      <section id="ln-valor" className="ln-valor">
        <div className="ln-valor__container">
          <h2 className="ln-section-title">Por qué elegir Niva</h2>
          <p className="ln-section-subtitle">
            La forma más segura y rápida de resolver tus necesidades del hogar
          </p>

          <div className="ln-cards">
            <div className="ln-card ln-card--1">
              <div className="ln-card__accent"></div>
              <div className="ln-card__icon ln-card__icon--shield"></div>
              <h3 className="ln-card__title">Perfiles verificados</h3>
              <p className="ln-card__text">
              La información publicada proviene directamente de cada usuario.
              </p>
            </div>

            <div className="ln-card ln-card--2">
              <div className="ln-card__accent"></div>
              <div className="ln-card__icon ln-card__icon--dollar"></div>
              <h3 className="ln-card__title">Transparencia total</h3>
              <p className="ln-card__text">
              Precios visibles desde el inicio, publicados directamente por cada usuario.
              </p>
            </div>

            <div className="ln-card ln-card--3">
              <div className="ln-card__accent"></div>
              <div className="ln-card__icon ln-card__icon--support"></div>
              <h3 className="ln-card__title">Soporte continuo</h3>
              <p className="ln-card__text">
              Podés contactarnos si necesitás asistencia relacionada con el uso de la plataforma.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section id="ln-test" className="ln-test">
        <div className="ln-test__container">
          <h2 className="ln-section-title">Lo que dicen nuestros usuarios</h2>
          
          <div 
            className="ln-slider"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`ln-testimonial ${index === activeTestimonial ? 'ln-testimonial--active' : ''}`}
              >
                <div className="ln-testimonial__content">
                  <div className="ln-testimonial__stars" aria-label="5 estrellas">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="ln-star"></span>
                    ))}
                  </div>
                  <p className="ln-testimonial__text">"{testimonial.text}"</p>
                  <div className="ln-testimonial__author">
                    <div 
                      className="ln-avatar" 
                      style={{ backgroundColor: testimonial.color }}
                      aria-hidden="true"
                    >
                      {testimonial.initial}
                    </div>
                    <div className="ln-testimonial__info">
                      <div className="ln-testimonial__name">{testimonial.name}</div>
                      <div className="ln-testimonial__location">{testimonial.location}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="ln-dots" role="tablist" aria-label="Selector de testimonios">
            {testimonials.map((_, index) => (
              <button
                key={index}
                role="tab"
                aria-selected={index === activeTestimonial}
                aria-label={`Testimonio ${index + 1}`}
                className={`ln-dot ${index === activeTestimonial ? 'ln-dot--active' : ''}`}
                onClick={() => setActiveTestimonial(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section id="ln-faq" className="ln-faq">
        <div className="ln-faq__container">
          <h2 className="ln-section-title">Preguntas frecuentes</h2>

          <div className="ln-faq__list">
            <details className="ln-faq__item">
              <summary className="ln-faq__question">
                ¿Cómo verifican a los profesionales?
              </summary>
              <div className="ln-faq__answer">
              Niva ofrece herramientas para que los usuarios puedan validar identidad o referencias de forma voluntaria. No garantizamos la veracidad de los datos ni asumimos responsabilidad por la información publicada por los usuarios.
              </div>
            </details>

            <details className="ln-faq__item">
              <summary className="ln-faq__question">
                ¿Qué pasa si no estoy satisfecho con el servicio?
              </summary>
              <div className="ln-faq__answer">
                Tenés 48 horas para reportar cualquier inconveniente. Podés comunicarte con nosotros para reportar el caso; ayudamos a facilitar la comunicación entre las partes, sin asumir obligación de resolución.
              </div>
            </details>

            <details className="ln-faq__item">
              <summary className="ln-faq__question">
                ¿Cuánto cuesta usar Niva?
              </summary>
              <div className="ln-faq__answer">
              El registro y la búsqueda son gratuitos. Niva puede cobrar una comisión por el uso de ciertas funciones o servicios, la cual se informará antes de confirmar cualquier pago.
              </div>
            </details>

            <details className="ln-faq__item">
              <summary className="ln-faq__question">
                ¿En qué zonas están disponibles?
              </summary>
              <div className="ln-faq__answer">
              Actualmente disponible en CABA con miles de usuarios registrados. Próximamente, expansión a GBA, Córdoba, Rosario y Mendoza.
              </div>
            </details>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="ln-foot">
        <div className="ln-foot__container">
          <div className="ln-foot__brand">
            <img src={logoCompleto} alt="Niva" className="ln-foot__logo-img" />
            <p className="ln-foot__tagline">Servicios del hogar con talento verificado</p>
          </div>

          <nav className="ln-foot__nav" aria-label="Navegación del pie de página">
            <a href="#ln-como" onClick={(e) => handleSmoothScroll(e, '#ln-como')}>Cómo funciona</a>
            <a href="#ln-valor" onClick={(e) => handleSmoothScroll(e, '#ln-valor')}>Beneficios</a>
            <a href="#ln-test" onClick={(e) => handleSmoothScroll(e, '#ln-test')}>Testimonios</a>
            <a href="#ln-faq" onClick={(e) => handleSmoothScroll(e, '#ln-faq')}>FAQs</a>
          </nav>

          <div className="ln-foot__contact">
            <p className="ln-foot__contact-text">¿Necesitás ayuda? Contactanos:</p>
            <a href="mailto:soporte@niva.lat" className="ln-foot__contact-email">soporte@niva.lat</a>
          </div>

          <div className="ln-foot__legal">
            <div className="ln-foot__disclaimer">
              <p><strong>Disclaimer Legal:</strong> Niva es una plataforma tecnológica que conecta personas. No participa en las contrataciones ni supervisa los servicios. Cada usuario es responsable de su conducta y de los acuerdos que establezca.</p>
            </div>
            <nav className="ln-foot__legal-links" aria-label="Enlaces legales">
              <a href="/terminos-condiciones" className="ln-foot__legal-link">Términos y Condiciones</a>
              <span className="ln-foot__legal-separator">•</span>
              <a href="/privacidad" className="ln-foot__legal-link">Política de Privacidad</a>
            </nav>
            <div className="ln-foot__copyright">
              © {new Date().getFullYear()} Niva. Todos los derechos reservados.
            </div>
            <div style={{ marginTop: 8, fontSize: '12px', color: '#9ca3af' }}>
              <a
                href="https://nivalat.statuspage.io/"
                target="_blank"
                rel="noreferrer"
                style={{ color: '#9ca3af', textDecoration: 'underline' }}
              >
                Estado del sistema
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
